// extracted by mini-css-extract-plugin
module.exports = {"boxname":"name-module--boxname--3kWxf"};